/**
 * Creates an HTML/CSS overlay for numbered map markers. Defined lazily when called
 * so google.maps is available (avoids "google is not defined" at module load).
 */
export function createNumberedMarkerOverlay(position, map, baseCircleUrl, number, name) {
  const displayNum = Math.min(99, Math.max(1, Math.floor(number)));

  const SIZE = 33;
  const ANCHOR_X = 16.5;
  const ANCHOR_Y = 33;

  class NumberedMarkerOverlay extends google.maps.OverlayView {
    constructor() {
      super();
      this.position = position;
      this.baseCircleUrl = baseCircleUrl;
      this.number = displayNum;
      this.name = name || '';
      this.div = null;
      this.setMap(map);
    }

    onAdd() {
      const div = document.createElement('div');
      div.className = 'numbered-marker-overlay';
      div.style.cssText = `position:absolute;cursor:pointer;width:${SIZE}px;height:${SIZE}px;`;
      div.innerHTML = `
        <img src="${this.baseCircleUrl}" alt="" style="width:100%;height:100%;display:block;pointer-events:none;object-fit:contain;" />
        <span style="position:absolute;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:bold;font-size:18px;pointer-events:none;text-shadow:none;">${this.number}</span>
      `;
      if (this.number >= 10) {
        div.querySelector('span').style.fontSize = '14px';
      }
      this.div = div;

      if (this.name) {
        const infoWindow = new google.maps.InfoWindow({ content: this.name });
        div.addEventListener('click', (event) => {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) {
              event.stopImmediatePropagation();
            }
          }
          infoWindow.open(this.getMap(), this);
        });
      }

      if (google.maps.OverlayView.preventMapHitsAndGesturesFrom) {
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(div);
      }

      this.getPanes().overlayMouseTarget.appendChild(div);
    }

    draw() {
      const projection = this.getProjection();
      if (!projection || !this.div) return;
      const pos = projection.fromLatLngToDivPixel(this.position);
      this.div.style.left = (pos.x - ANCHOR_X) + 'px';
      this.div.style.top = (pos.y - ANCHOR_Y) + 'px';
    }

    onRemove() {
      if (this.div && this.div.parentNode) {
        this.div.parentNode.removeChild(this.div);
      }
      this.div = null;
    }

    getPosition() {
      return this.position;
    }
  }

  return new NumberedMarkerOverlay();
}
